module.exports = __webpack_public_path__ + "static/media/user.791f8ce4.svg";